import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import BarGraph from "../../../general/BarGraph";
import styles from "./InfraL3.module.css";
import { InfraStore } from "./InfraStore";

function InfraL3({ distrito }) {
  const [infraestrutura, setInfraestrutura] = useState(null);

  const situacaoEstradasValue = InfraStore(
    (state) => state.situacaoEstradasValue
  );

  const manutencaoEstradasValue = InfraStore(
    (state) => state.manutencaoEstradasValue
  );

  const setInfraImage = InfraStore((state) => state.setInfraImage);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [infraestrutura] = await Promise.all([
          Api.getInfraestrutura(distrito, situacaoEstradasValue, manutencaoEstradasValue),
        ]);
        setInfraestrutura(Functions.buildBarGraph(infraestrutura));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [distrito, situacaoEstradasValue, manutencaoEstradasValue]);

  return (
    <div className={styles.infraL3}>
      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {infraestrutura && (
            <BarGraph
              data={infraestrutura}
              text="INFRAESTRUTURA"
              onImageReady={setInfraImage}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default InfraL3;
